export default {
  newKeyword: {
    id: 'card_new_keyword',
    defaultMessage: 'new',
  },
  afterTradin: {
    id: 'card_after_buyback',
    defaultMessage: 'after tradein',
  },
  dueToday: {
    id: 'product_card_price_due_today',
    defaultMessage: 'due today',
  },
  flashSalesDiscount: {
    id: 'product_card_price_flash_sales_discount',
    defaultMessage: 'After {discount} applied at checkout',
  },
  flashSalesDiscountTooltip: {
    id: 'product_card_flash_sales_tooltip',
    defaultMessage:
      'This deal is limited to one per purchase and is not stackable with other promotions. The item is sold by a third-party with Back Market providing the promo code, not the seller.',
  },
  sellerFlashSalesDiscountTooltip: {
    id: 'seller_flash_sales_tag_tooltip_short',
    defaultMessage:
      'The lowest price for this product in this exact configuration on Back Market in the 30 days prior to {start_date}. This reference updates on {end_date}.',
  },
  sellerFlashSalesDiscount: {
    id: 'product_card_price_seller_flash_sales_discount',
    defaultMessage: 'Save {price}',
  },
  lastLowestPrice: {
    id: 'product_card_last_lowest_price',
    defaultMessage: 'Last lowest price : {price}',
  },
  priceSRLabel: {
    id: 'product_card_price_sr_label',
    defaultMessage: 'Refurbished price:',
  },
  newPriceSRLabel: {
    id: 'product_card_new_price_sr_label',
    defaultMessage: 'Versus {price} new',
  },
  moreInfoSRLabel: {
    id: 'product_card_more_info_sr_label',
    defaultMessage: 'More information',
  },
} as const
